import React from 'react';
import PropTypes from 'prop-types';
import './ButtonWithIcon.scss';
import RadioOn from 'assets/icons/radioOn@2x.png';
import RadioOff from 'assets/icons/radioOff@2x.png';

const ButtonWithIcon = ({
  icon, iconActive, title, isSelected, onButtonClick, noOfButton,
}) => (
  <button type="button" className={`nw-button nw-button--with-icon nw-button--with-icon--${noOfButton}`} onClick={onButtonClick}>
    {isSelected
      ? <img src={iconActive} alt="" />
      : <img src={icon} alt="" />
          }
    <span>{title}</span>

    {isSelected
      ? <img src={RadioOn} alt="selected" className="checkbox" />
      : <img src={RadioOff} alt="not selected" className="checkbox" />
          }
  </button>
);

ButtonWithIcon.propTypes = {
  /** button Icon */
  icon: PropTypes.string,
  /** button title */
  title: PropTypes.string,
  /** this should be state, on button click, value should be true */
  isSelected: PropTypes.bool,
  /** pass click event function as props */
  onButtonClick: PropTypes.func,
  /** No. of button to modify button width */
  noOfButton: PropTypes.number,
};

ButtonWithIcon.defaultProps = {
  icon: null,
  title: null,
  isSelected: false,
  onButtonClick: () => {},
  noOfButton: null,
};

export default ButtonWithIcon;
